/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Banners_Inbox_TitleInputs */

const de_banners_inbox_title = /** @type {(inputs: Banners_Inbox_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benachrichtigungen`)
};

/** @type {(inputs: Banners_Inbox_TitleInputs) => LocalizedString} */
const en_banners_inbox_title = de_banners_inbox_title;

/**

* @param {Banners_Inbox_TitleInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const banners_inbox_title = /** @type {((inputs?: Banners_Inbox_TitleInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Banners_Inbox_TitleInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_banners_inbox_title(inputs)
	return en_banners_inbox_title(inputs)
});